import React from 'react'
import FullscreenOutlinedIcon from '@material-ui/icons/FullscreenOutlined'

function LightboxHeaderFullscreen() {
  return <FullscreenOutlinedIcon />
}

export default LightboxHeaderFullscreen
